import {
  CalendarIcon,
  ChartIcon,
  GKModal,
  Grid2,
  LabelIcon,
  Typography,
  UserIcon,
} from "components";
import { CalCulationHistory, CalculationRowData } from "interfaces/Revenue";
import { isEmpty, map } from "lodash";
import { useGetFeeCalculationByIdQuery } from "store/features/Revenue/FeeCalculationApi";
import { GKModalProps } from "utils/commonInterface";
import { matchDate } from "utils/helpers";
import { FeeAnnexureTable, FeeCard, feeSections } from "../utils";

interface Props {
  calculationRowData: CalculationRowData;
}

const CalculationDetailsModal = (props: GKModalProps & Props) => {
  const { open, setOpen, calculationRowData } = props;

  const { data, isFetching } = useGetFeeCalculationByIdQuery(
    calculationRowData?.id,
  );

  return (
    <GKModal
      modalTitle="Fee Calculations Details"
      open={open}
      setOpen={setOpen}
      loading={isFetching}
      width={"960px"}
    >
      <Grid2 container spacing={3}>
        <Grid2 container size={6} spacing={"12px"}>
          <Grid2 size={12} display={"flex"} alignItems={"center"} gap={0.5}>
            <ChartIcon color="var(--neutral-500)" />
            <Typography
              fontWeight={500}
              color="var(--neutral-500)"
              display="flex"
              alignItems="center"
              gap={1}
            >
              Portfolio Name - Code:
              <Typography fontWeight={500} color="var(--black)">
                {data?.data?.portfolioName} -{data?.data?.portfolioId}
              </Typography>
            </Typography>
          </Grid2>
          <Grid2 size={12} display={"flex"} alignItems={"center"} gap={0.5}>
            <UserIcon color="var(--neutral-500)" />
            <Typography
              fontWeight={500}
              color="var(--neutral-500)"
              display="flex"
              alignItems="center"
              gap={1}
            >
              Client Name - Code:
              <Typography fontWeight={500} color="var(--black)">
                {data?.data?.clientName} - {data?.data?.clientCode}
              </Typography>
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2 container size={6} spacing={"12px"}>
          <Grid2 size={12} display={"flex"} alignItems={"center"} gap={0.5}>
            <LabelIcon color="var(--neutral-500)" />
            <Typography
              fontWeight={500}
              color="var(--neutral-500)"
              display="flex"
              alignItems="center"
              gap={1}
            >
              Plan Name:
              <Typography fontWeight={500} color="var(--black)">
                {data?.data?.feePlanName || "-"}
              </Typography>
            </Typography>
          </Grid2>
          <Grid2 size={12} display={"flex"} alignItems={"center"} gap={0.5}>
            <CalendarIcon color="var(--neutral-500)" />
            <Typography
              fontWeight={500}
              color="var(--neutral-500)"
              display="flex"
              alignItems="center"
              gap={1}
            >
              Period:
              <Typography fontWeight={500} color="var(--black)">
                {matchDate(data?.data?.startDate, "DD/MM/YYYY")} -{" "}
                {matchDate(data?.data?.endDate, "DD/MM/YYYY")}
              </Typography>
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2 size={12}>
          {map(data?.data?.feePlans, (item: CalCulationHistory) => {
            const visibleFeeSections = feeSections.filter(({ key }) => {
              const feeData = item?.[key];
              return !isEmpty(feeData);
            });

            const gridSize =
              visibleFeeSections.length > 0
                ? Math.floor(12 / visibleFeeSections.length)
                : visibleFeeSections.length > 1
                  ? 6
                  : 12;

            const annexureSections = visibleFeeSections.filter(({ key }) => {
              const feeData = item?.[key];
              if (!feeData || feeData.annexure?.length === 0) return false;
              if (key === "managementFee" && feeData?.feeType === "Flat Fee")
                return false;
              return true;
            });

            return (
              <Grid2 container size={12} display={"flex"} spacing={3}>
                <Grid2 container size={12} display={"flex"}>
                  {visibleFeeSections.map(({ key, label }) => {
                    const feeData = item?.[key];

                    return (
                      <Grid2 key={key} size={gridSize}>
                        <FeeCard label={label} feeData={feeData} />
                      </Grid2>
                    );
                  })}
                </Grid2>
                {annexureSections.length > 0 && (
                  <Grid2 container size={12} mt={1} spacing={"16px"}>
                    <Grid2 size={12}>
                      <Typography
                        fontSize={12}
                        fontWeight={600}
                        color="var(--neutral-500)"
                        textTransform={"uppercase"}
                      >
                        calculation details
                      </Typography>
                    </Grid2>

                    <Grid2 container size={12}>
                      {visibleFeeSections.map(({ key, label }) => {
                        const feeData = item?.[key];

                        if (!feeData || feeData.annexure?.length === 0)
                          return null;

                        if (
                          key === "managementFee" &&
                          feeData?.feeType === "Flat Fee"
                        )
                          return null;

                        return (
                          <Grid2 size={12}>
                            <FeeAnnexureTable
                              type={key}
                              label={label}
                              feeData={feeData}
                            />
                          </Grid2>
                        );
                      })}
                    </Grid2>
                  </Grid2>
                )}
              </Grid2>
            );
          })}
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default CalculationDetailsModal;
